module.exports = __webpack_public_path__ + "static/sponsorship_img-05-b-7996a4769c81903c727c358ae9d9feeb.jpg";